<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>Webアカウント一覧</h2>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <v-btn
          v-if="$route.params.subscription_id"
          :to="{ name: 'CreateWebAccountSubscription', params: {subscription_id: $route.params.subscription_id}}"
          class="title-btn red white--text"
        >
          新規登録
        </v-btn>
        <v-btn
          v-else
          :to="{ name: 'CreateWebAccount'}"
          class="title-btn red white--text"
        >
          新規登録
        </v-btn>
      </v-col>
    </v-row>
    <template v-if="$route.params.subscription_id">
    <v-row>
      <v-col>
        <v-data-table
          :headers="subscription_headers"
          :items="selectedSubscription"
          hide-default-footer
        >
        <template v-slot:item.web_accounts="{ item }">
            <span v-if="item.webaccount_max_count">{{ item.webaccount_count }}/{{ item.webaccount_max_count }}</span>
        </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    </template>
    <v-row>
      <v-col
        cols="3"
      >
        <v-text-field
          label="検索"
          v-model="params.search"
          @change="getWebAccounts"
          dense
        >
        </v-text-field>
      </v-col>
      <v-col
        cols="3"
      >
        <v-switch
          label="削除データも表示"
          v-model="contain_deleted"
          dense
          @change="getWebAccounts"
        >
        </v-switch>
      </v-col>
      <v-col
          cols="4"
      >
        <v-btn
          class="title-btn mr-4"
          @click="data_download"
        >
          データダウンロード
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="item_total"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getWebAccounts"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="default"
            :to="{ name: 'EditWebAccount', params: {id: item.id}}"
          >
            詳細
          </v-btn>
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                dense
                @click="deleteConfirm(item)"
              >
                <v-list-item-title>削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="Webアカウント削除"
          message="Webアカウントを削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteWebAccount"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      items: [],
      params: {
        search: '',
        is_deleted: false,
      },
      loading: false,
      item_total: 0,
      options: {
        itemsPerPage: 20,
      },
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      subscription_headers: [
        {text: "顧客コード", value: "client.cd"},
        {text: "顧客名称", value: "client.name_combined"},
        {text: "電話番号", value: "client.tel"},
        {text: "商品", value: "productdetail.name"},
        {text: "部数", value: "sum_amount"},
        {text: "ステータス", value: "status.name"},
        {text: `WEBアカウント`, value: "web_accounts"},
      ],
      headers: [
        {text: "email", value: "email"},
        {text: "ユーザー名", value: "username"},
        {text: "管理者", value: "is_admin"},
        {text: "退会済み", value: "is_deleted"},
        {text: "操作", value: "action", width: "130px"},
      ],
      selectedSubscription: [],
      deleteItem: {},
      contain_deleted: false,
    }
  },
  async created() {
    if (this.$route.params.subscription_id) {
      await this.getSubscriptions();
    }
  },
  watch: {
    contain_deleted: function() {
      if (this.contain_deleted) {
        this.params.is_deleted = null;
      } else {
        this.params.is_deleted = false;
      }
    }
  },
  methods: {
    async getSubscriptions() {
      const subscription_id = this.$route.params.subscription_id;
      if (!subscription_id) {
        return;
      }
      try {
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/sub/subscriptions/${subscription_id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.selectedSubscription = [response.data]
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
      }
    },
    async getWebAccounts() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        if (this.$route.params.subscription_id) {
          this.params.webaccountsubscription__subscription = this.$route.params.subscription_id;
        }
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/`,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.loading = false;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteWebAccount() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/${this.deleteItem.id}/`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getWebAccounts();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    },
    async data_download() {
      try {
        const response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/accounts/list_download/`,
          {
            params: this.params,
            responseType: "blob",
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "webaccount_list.xlsx");
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "取得できませんでした", type: "error"});
      }
    },
  }
}
</script>